import { useCallback } from "react";
import { useAllTenants } from "~api/tenants.ts";
import { createModalProvider } from "~components/shared/ModalContext/ModalContext.tsx";
import { useCurrentTenant } from "~contexts/CurrentTenantContext/CurrentTenantContext.tsx";
import type { Resource } from "~lib/resourceHelpers.ts";
import { ResourceType } from "~lib/resourceHelpers.ts";
import type { ForeignTenantToolWarningData } from "./ForeignTenantToolWarningDialog.tsx";
import { ForeignTenantToolWarningDialog } from "./ForeignTenantToolWarningDialog.tsx";

const {
  provider: ForeignTenantToolWarningProvider,
  hook: useForeignTenantToolWarningModal,
} = createModalProvider<ForeignTenantToolWarningData>(
  ForeignTenantToolWarningDialog,
);

export { ForeignTenantToolWarningProvider };

export function useForeignTenantToolWarning() {
  const { openModal } = useForeignTenantToolWarningModal();
  const currentTenant = useCurrentTenant();
  const { data: allTenants } = useAllTenants({ includeInactive: true });

  return useCallback(
    (resource: Resource, onConfirm: () => void) => {
      if (resource.type !== ResourceType.TOOL) {
        onConfirm();
        return;
      }
      if (!resource.tenantId || resource.tenantId === currentTenant.id) {
        onConfirm();
        return;
      }
      const tenantName =
        allTenants?.find((t) => t.id === resource.tenantId)?.name ??
        resource.tenantId;
      openModal({
        toolDisplayName: resource.displayName ?? "",
        tenantName,
        onConfirm,
      });
    },
    [openModal, currentTenant.id, allTenants],
  );
}
